import { Directive,ElementRef } from '@angular/core';

@Directive({
  selector: '[starSign]'
})
export class StarSignDirective {

  constructor(
    private el:ElementRef
  ) { 
    this.setup();
  }
  setup() {
    const parent = this.el.nativeElement.innerHtml;
    var starSignText = "* ";
    var starSignColor = starSignText.fontcolor("red");
    this.el.nativeElement.innerHtml = starSignText + parent;
  }

}
